import React, { useEffect, useState } from 'react'
import { loadAndInitIfNeeded } from '../utils/pixel'
import { setGoogleAdsConsent } from '../utils/googleAds'

const STORAGE_KEY = 'casertp_cookie_consent'

export default function CookieBanner() {
  const [consent, setConsent] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) } catch { return null }
  })

  useEffect(() => {
    setGoogleAdsConsent(consent === true)
    if (consent === true) {
      // load pixel after consent
      loadAndInitIfNeeded().catch(() => {})
    }
  }, [consent])

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(true))
    setConsent(true)
  }

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(false))
    setConsent(false)
  }

  if (consent !== null) return null

  return (
    <div className="fixed bottom-6 left-1/2 md:left-6 z-50 w-full max-w-2xl px-4 -translate-x-1/2 md:translate-x-0">
      <div className="bg-[#0B0D0F]/95 border border-[#2A2D31] rounded-3xl p-5 text-base text-white backdrop-blur-md shadow-xl flex flex-col gap-4 min-w-[320px] md:min-w-[360px]">
        <div className="flex-1">
          <strong>We use cookies</strong> to improve your experience and to measure ads performance. Accept to enable personalized ads and tracking.
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <button onClick={decline} className="w-full sm:w-auto px-4 py-3 rounded-2xl border border-[#4B5563] text-white/80 hover:text-white">Decline</button>
          <button onClick={accept} className="w-full sm:w-auto px-4 py-3 rounded-2xl bg-[#FF6B00] text-black font-semibold">Accept</button>
        </div>
      </div>
    </div>
  )
}
